import React, { useEffect, useState } from "react";
import { Typography, Rating, TextField, Button } from "@mui/material";
import "./Feedback.css";
import { FeedbackRequest } from "../../models/IFeedback";
import FeedbackService from "../../services/feedback.service";
import TokenService from "../../services/token.service";
import { TokenPayload } from "../../models/IToken";
import { clearSessionDetails } from "../../services/storage.service";
import { useNavigate } from "react-router-dom";
import { environment } from "../../environment/environment";
import { useRecoilState, useRecoilValue } from "recoil";
import { isMeetingTerminated } from "../../atom/atom";
import useSnackbar from "../../utils/useSnackbar";

const Feedback: React.FC = () => {
  const [rating, setRating] = useState<number>(0);
  const [review, setReview] = useState<string>("");
  const [charCount, setCharCount] = useState<number>(0);

  const [isMeetingTerminatedByAdmin, setIsMeetingTerminatedByAdmin] = useRecoilState(isMeetingTerminated);
  const { showSnackbar, SnackbarComponent } = useSnackbar();

    const handleReviewChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newReview = e.target.value.slice(0, 50);
    setReview(newReview);
    setCharCount(newReview.length);
  };

  const navigateToHome = useNavigate();

  const getSessionId = () => {
    let parsedToken: TokenPayload = TokenService.parseToken(true, "");
    return parsedToken.video.room;
  };

  const getParticipantName = () => {
    let parsedToken: TokenPayload = TokenService.parseToken(true, "");
    let participantDetails = JSON.parse(parsedToken.metadata);
    return participantDetails.pName;
  };
  const handleSubmitReview = async () => {
    const feedback: FeedbackRequest = {
      overallRating: rating,
      remark: review,
      tenentAlias: environment.tenantAlias,
      name: getParticipantName(),
    };
    try {
      const response = await FeedbackService.submitFeedback(
        getSessionId(),
        feedback
      );
      if (response) {
        clearSessionDetails();
        navigateToHome("/");
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
    }
  };

  useEffect(() => {
    !!(window as any).electronAPI && (window as any).electronAPI.updateTitle('');

    if(isMeetingTerminatedByAdmin){
      showSnackbar({message: 'Meeting is terminated by the admin', severity: 'warning'});
      setIsMeetingTerminatedByAdmin(false);
    }
    if (!TokenService.isTokenAvailable()) {
      navigateToHome("/");
    }
  }, []);

  const handleSkip = async () => {
    clearSessionDetails();
    navigateToHome("/");
  };

  return (
    <div>
      {SnackbarComponent}
      <div className="feedback-page-container">

      <Typography
        variant="h4"
        gutterBottom
        style={{
          marginTop: "30px",
        }}
      >
        Please rate the call quality?
      </Typography>
      <div className="feedback-card">
        <Rating
          size="large"
          value={rating}
          onChange={(_, newValue) => setRating(newValue ?? 0)}
          sx={{
            fontSize: "2.8rem",
          }}
        />
        <TextField
          label="Leave a review (optional)"
          value={review}
          onChange={handleReviewChange}
          multiline
          rows={4}
          fullWidth
          inputProps={{ maxLength: 50 }}
        />
        <div className="characterCount-container">
          <Typography variant="body2" color="textSecondary">
            {`(${charCount}/50)`}
          </Typography>
        </div>

        <div className="feedback-btn-container">
          <Button variant="outlined" onClick={handleSkip}>
            Skip
          </Button>
          <Button
            disabled={rating === 0}
            variant="contained"
            onClick={handleSubmitReview}
          >
            Submit Review
          </Button>
        </div>
      </div>
    </div>
    </div>
    
  );
};

export default Feedback;
